/**
 * QuantaBit CMS SDK - 国际化 i18n
 * 支持多语言的 CMS 内容管理系统
 */

// 支持的语言列表
export const SUPPORTED_LANGUAGES = ['en', 'zh', 'ja', 'ko'];

// 翻译消息
export const messages = {
  zh: {
    // 通用
    loading: '加载中...',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    preview: '预览',
    publish: '发布',
    draft: '草稿',
    confirm: '确认',
    success: '操作成功',
    error: '操作失败',
    search: '搜索',
    filter: '筛选',
    sort: '排序',
    refresh: '刷新',
    more: '更多',
    
    // 内容类型
    article: '文章',
    post: '帖子',
    image: '图片',
    video: '视频',
    audio: '音频',
    document: '文档',
    
    // 内容状态
    statusDraft: '草稿',
    statusPending: '待审核',
    statusApproved: '已发布',
    statusRejected: '已拒绝',
    statusArchived: '已归档',
    statusScheduled: '定时发布',
    
    // 内容管理
    createContent: '创建内容',
    editContent: '编辑内容',
    deleteContent: '删除内容',
    contentTitle: '标题',
    contentBody: '正文',
    contentSummary: '摘要',
    contentCover: '封面图',
    contentTags: '标签',
    contentCategory: '分类',
    contentAuthor: '作者',
    contentCreatedAt: '创建时间',
    contentUpdatedAt: '更新时间',
    contentPublishedAt: '发布时间',
    contentViews: '浏览量',
    contentLikes: '点赞数',
    contentComments: '评论数',
    
    // 编辑器
    editorPlaceholder: '开始写作...',
    editorBold: '粗体',
    editorItalic: '斜体',
    editorUnderline: '下划线',
    editorStrikethrough: '删除线',
    editorHeading: '标题',
    editorQuote: '引用',
    editorCode: '代码',
    editorLink: '链接',
    editorImage: '插入图片',
    editorVideo: '插入视频',
    editorList: '列表',
    editorOrderedList: '有序列表',
    editorUnorderedList: '无序列表',
    editorAlign: '对齐',
    editorAlignLeft: '左对齐',
    editorAlignCenter: '居中',
    editorAlignRight: '右对齐',
    
    // 媒体库
    mediaLibrary: '媒体库',
    uploadMedia: '上传媒体',
    selectMedia: '选择媒体',
    dragDropHint: '拖拽文件到此处或点击上传',
    uploadProgress: '上传进度',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    fileSize: '文件大小',
    fileType: '文件类型',
    fileDimensions: '尺寸',
    
    // 版本管理
    versionHistory: '版本历史',
    versionRestore: '恢复版本',
    versionCompare: '版本对比',
    currentVersion: '当前版本',
    previousVersion: '上一版本',
    versionBy: '修改人',
    versionAt: '修改时间',
    
    // 审核
    review: '审核',
    approve: '通过',
    reject: '拒绝',
    reviewComment: '审核意见',
    reviewHistory: '审核记录',
    reviewPending: '待审核',
    reviewApproved: '已通过',
    reviewRejected: '已拒绝',
    
    // 分类和标签
    categories: '分类',
    tags: '标签',
    addCategory: '添加分类',
    addTag: '添加标签',
    manageCategories: '管理分类',
    manageTags: '管理标签',
    
    // SEO
    seoTitle: 'SEO 标题',
    seoDescription: 'SEO 描述',
    seoKeywords: 'SEO 关键词',
    seoSlug: 'URL Slug',
    
    // 权限
    visibility: '可见性',
    public: '公开',
    private: '私有',
    membersOnly: '仅会员可见',
    password: '密码保护',
    
    // 定时发布
    schedulePublish: '定时发布',
    publishNow: '立即发布',
    scheduledFor: '计划发布时间',
    
    // 错误消息
    errorTitleRequired: '请输入标题',
    errorContentRequired: '请输入内容',
    errorSaveFailed: '保存失败，请重试',
    errorLoadFailed: '加载失败，请重试',
    errorDeleteFailed: '删除失败，请重试',
    errorUploadFailed: '上传失败，请重试',
    errorFileTooLarge: '文件过大',
    errorFileTypeNotSupported: '不支持的文件类型',
    
    // 确认弹窗
    confirmDelete: '确定删除此内容？此操作不可撤销。',
    confirmPublish: '确定发布此内容？',
    confirmUnpublish: '确定取消发布此内容？',
    confirmRestore: '确定恢复此版本？',
    
    // 空状态
    noContent: '暂无内容',
    noResults: '无搜索结果',
    noVersions: '暂无版本记录',
    noMedia: '暂无媒体文件',
  },
  ja: {
    // 通用
    loading: '読み込み中...',
    save: '保存',
    cancel: 'キャンセル',
    delete: '削除',
    edit: '編集',
    preview: 'プレビュー',
    publish: '公開',
    draft: '下書き',
    confirm: '確認',
    success: '操作成功',
    error: '操作失敗',
    search: '検索',
    filter: 'フィルター',
    sort: '並べ替え',
    refresh: '更新',
    more: 'もっと見る',
    
    // 内容类型
    article: '記事',
    post: '投稿',
    image: '画像',
    video: '動画',
    audio: '音声',
    document: 'ドキュメント',
    
    // 内容状态
    statusDraft: '下書き',
    statusPending: '審査待ち',
    statusApproved: '公開済み',
    statusRejected: '拒否されました',
    statusArchived: 'アーカイブ済み',
    statusScheduled: '予約投稿',
    
    // 内容管理
    createContent: 'コンテンツ作成',
    editContent: 'コンテンツ編集',
    deleteContent: 'コンテンツ削除',
    contentTitle: 'タイトル',
    contentBody: '本文',
    contentSummary: '概要',
    contentCover: 'カバー画像',
    contentTags: 'タグ',
    contentCategory: 'カテゴリー',
    contentAuthor: '作成者',
    contentCreatedAt: '作成日時',
    contentUpdatedAt: '更新日時',
    contentPublishedAt: '公開日時',
    contentViews: '閲覧数',
    contentLikes: 'いいね数',
    contentComments: 'コメント数',
    
    // 编辑器
    editorPlaceholder: '書き始める...',
    editorBold: '太字',
    editorItalic: '斜体',
    editorUnderline: '下線',
    editorStrikethrough: '取り消し線',
    editorHeading: 'タイトル',
    editorQuote: '引用',
    editorCode: 'コード',
    editorLink: 'リンク',
    editorImage: '画像挿入',
    editorVideo: '動画挿入',
    editorList: 'リスト',
    editorOrderedList: '番号付きリスト',
    editorUnorderedList: '箇条書きリスト',
    editorAlign: '配置',
    editorAlignLeft: '左揃え',
    editorAlignCenter: '中央揃え',
    editorAlignRight: '右揃え',
    
    // 媒体库
    mediaLibrary: 'メディアライブラリ',
    uploadMedia: 'メディアアップロード',
    selectMedia: 'メディア選択',
    dragDropHint: 'ここにファイルをドラッグするか、クリックしてアップロード',
    uploadProgress: 'アップロード進捗',
    uploadSuccess: 'アップロード成功',
    uploadFailed: 'アップロード失敗',
    fileSize: 'ファイルサイズ',
    fileType: 'ファイルの種類',
    fileDimensions: 'サイズ',
    
    // 版本管理
    versionHistory: 'バージョン履歴',
    versionRestore: 'バージョン復元',
    versionCompare: 'バージョン比較',
    currentVersion: '現在のバージョン',
    previousVersion: '前のバージョン',
    versionBy: '変更者',
    versionAt: '変更日時',
    
    // 审核
    review: '審査',
    approve: '承認',
    reject: '拒否',
    reviewComment: '審査コメント',
    reviewHistory: '審査履歴',
    reviewPending: '審査待ち',
    reviewApproved: '承認済み',
    reviewRejected: '拒否されました',
    
    // 分类和标签
    categories: 'カテゴリー',
    tags: 'タグ',
    addCategory: 'カテゴリー追加',
    addTag: 'タグ追加',
    manageCategories: 'カテゴリー管理',
    manageTags: 'タグ管理',
    
    // SEO
    seoTitle: 'SEOタイトル',
    seoDescription: 'SEO説明',
    seoKeywords: 'SEOキーワード',
    seoSlug: 'URL Slug',
    
    // 权限
    visibility: '公開範囲',
    public: '公開',
    private: '非公開',
    membersOnly: 'メンバー限定',
    password: 'パスワード保護',
    
    // 定时发布
    schedulePublish: '予約投稿',
    publishNow: '今すぐ公開',
    scheduledFor: '公開予定日時',
    
    // 错误消息
    errorTitleRequired: 'タイトルを入力',
    errorContentRequired: '内容を入力',
    errorSaveFailed: '保存に失敗しました。再試行してください',
    errorLoadFailed: '読み込みに失敗しました。再試行してください',
    errorDeleteFailed: '削除に失敗しました。再試行してください',
    errorUploadFailed: 'アップロードに失敗しました。再試行してください',
    errorFileTooLarge: 'ファイルが大きすぎます',
    errorFileTypeNotSupported: 'サポートされていないファイル形式です',
    
    // 确认弹窗
    confirmDelete: 'このコンテンツを削除しますか？この操作は元に戻せません。',
    confirmPublish: 'このコンテンツを公開しますか？',
    confirmUnpublish: '公開を取り消しますか？',
    confirmRestore: 'このバージョンを復元しますか？',
    
    // 空状态
    noContent: 'コンテンツなし',
    noResults: '検索結果なし',
    noVersions: 'バージョン履歴なし',
    noMedia: 'メディアファイルなし',
  },
  ko: {
    // 通用
    loading: '로딩 중...',
    save: '저장',
    cancel: '취소',
    delete: '삭제',
    edit: '편집',
    preview: '미리보기',
    publish: '게시',
    draft: '초안',
    confirm: '확인',
    success: '성공적으로 처리됨',
    error: '작업 실패',
    search: '검색',
    filter: '필터',
    sort: '정렬',
    refresh: '새로고침',
    more: '더 보기',
    
    // 内容类型
    article: '기사',
    post: '게시물',
    image: '이미지',
    video: '비디오',
    audio: '오디오',
    document: '문서',
    
    // 内容状态
    statusDraft: '초안',
    statusPending: '심사 대기 중',
    statusApproved: '게시됨',
    statusRejected: '거부됨',
    statusArchived: '보관됨',
    statusScheduled: '예약 게시',
    
    // 内容管理
    createContent: '콘텐츠 만들기',
    editContent: '콘텐츠 편집',
    deleteContent: '콘텐츠 삭제',
    contentTitle: '제목',
    contentBody: '본문',
    contentSummary: '요약',
    contentCover: '커버 이미지',
    contentTags: '태그',
    contentCategory: '카테고리',
    contentAuthor: '작성자',
    contentCreatedAt: '작성 시간',
    contentUpdatedAt: '업데이트 시간',
    contentPublishedAt: '게시 시간',
    contentViews: '조회수',
    contentLikes: '좋아요 수',
    contentComments: '댓글 수',
    
    // 编辑器
    editorPlaceholder: '작성 시작...',
    editorBold: '굵게',
    editorItalic: '기울임꼴',
    editorUnderline: '밑줄',
    editorStrikethrough: '취소선',
    editorHeading: '제목',
    editorQuote: '인용',
    editorCode: '코드',
    editorLink: '링크',
    editorImage: '이미지 삽입',
    editorVideo: '비디오 삽입',
    editorList: '목록',
    editorOrderedList: '번호 매기기 목록',
    editorUnorderedList: '글머리 기호 목록',
    editorAlign: '정렬',
    editorAlignLeft: '왼쪽 정렬',
    editorAlignCenter: '가운데 정렬',
    editorAlignRight: '오른쪽 정렬',
    
    // 媒体库
    mediaLibrary: '미디어 라이브러리',
    uploadMedia: '미디어 업로드',
    selectMedia: '미디어 선택',
    dragDropHint: '여기로 파일을 드래그하거나 클릭하여 업로드',
    uploadProgress: '업로드 진행',
    uploadSuccess: '업로드 성공',
    uploadFailed: '업로드 실패',
    fileSize: '파일 크기',
    fileType: '파일 유형',
    fileDimensions: '크기',
    
    // 版本管理
    versionHistory: '버전 기록',
    versionRestore: '버전 복원',
    versionCompare: '버전 비교',
    currentVersion: '현재 버전',
    previousVersion: '이전 버전',
    versionBy: '수정자',
    versionAt: '수정 시간',
    
    // 审核
    review: '심사',
    approve: '승인',
    reject: '거부',
    reviewComment: '심사 의견',
    reviewHistory: '심사 기록',
    reviewPending: '심사 대기 중',
    reviewApproved: '승인됨',
    reviewRejected: '거부됨',
    
    // 分类和标签
    categories: '카테고리',
    tags: '태그',
    addCategory: '카테고리 추가',
    addTag: '태그 추가',
    manageCategories: '카테고리 관리',
    manageTags: '태그 관리',
    
    // SEO
    seoTitle: 'SEO 제목',
    seoDescription: 'SEO 설명',
    seoKeywords: 'SEO 키워드',
    seoSlug: 'URL Slug',
    
    // 权限
    visibility: '공개 범위',
    public: '공개',
    private: '비공개',
    membersOnly: '회원 전용',
    password: '비밀번호 보호',
    
    // 定时发布
    schedulePublish: '예약 게시',
    publishNow: '즉시 게시',
    scheduledFor: '예정된 게시 시간',
    
    // 错误消息
    errorTitleRequired: '제목을 입력하세요',
    errorContentRequired: '내용을 입력하세요',
    errorSaveFailed: '저장 실패. 다시 시도해주세요',
    errorLoadFailed: '로드 실패. 다시 시도해주세요',
    errorDeleteFailed: '삭제 실패. 다시 시도해주세요',
    errorUploadFailed: '업로드 실패. 다시 시도해주세요',
    errorFileTooLarge: '파일이 너무 큽니다',
    errorFileTypeNotSupported: '지원되지 않는 파일 형식',
    
    // 确认弹窗
    confirmDelete: '이 콘텐츠를 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.',
    confirmPublish: '이 콘텐츠를 게시하시겠습니까?',
    confirmUnpublish: '게시를 취소하시겠습니까?',
    confirmRestore: '이 버전을 복원하시겠습니까?',
    
    // 空状态
    noContent: '콘텐츠 없음',
    noResults: '검색 결과 없음',
    noVersions: '버전 기록 없음',
    noMedia: '미디어 파일 없음',
  },
  
  en: {
    // General
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    preview: 'Preview',
    publish: 'Publish',
    draft: 'Draft',
    confirm: 'Confirm',
    success: 'Success',
    error: 'Error',
    search: 'Search',
    filter: 'Filter',
    sort: 'Sort',
    refresh: 'Refresh',
    more: 'More',
    
    // Content Types
    article: 'Article',
    post: 'Post',
    image: 'Image',
    video: 'Video',
    audio: 'Audio',
    document: 'Document',
    
    // Content Status
    statusDraft: 'Draft',
    statusPending: 'Pending Review',
    statusApproved: 'Published',
    statusRejected: 'Rejected',
    statusArchived: 'Archived',
    statusScheduled: 'Scheduled',
    
    // Content Management
    createContent: 'Create Content',
    editContent: 'Edit Content',
    deleteContent: 'Delete Content',
    contentTitle: 'Title',
    contentBody: 'Body',
    contentSummary: 'Summary',
    contentCover: 'Cover Image',
    contentTags: 'Tags',
    contentCategory: 'Category',
    contentAuthor: 'Author',
    contentCreatedAt: 'Created At',
    contentUpdatedAt: 'Updated At',
    contentPublishedAt: 'Published At',
    contentViews: 'Views',
    contentLikes: 'Likes',
    contentComments: 'Comments',
    
    // Editor
    editorPlaceholder: 'Start writing...',
    editorBold: 'Bold',
    editorItalic: 'Italic',
    editorUnderline: 'Underline',
    editorStrikethrough: 'Strikethrough',
    editorHeading: 'Heading',
    editorQuote: 'Quote',
    editorCode: 'Code',
    editorLink: 'Link',
    editorImage: 'Insert Image',
    editorVideo: 'Insert Video',
    editorList: 'List',
    editorOrderedList: 'Ordered List',
    editorUnorderedList: 'Unordered List',
    editorAlign: 'Align',
    editorAlignLeft: 'Align Left',
    editorAlignCenter: 'Center',
    editorAlignRight: 'Align Right',
    
    // Media Library
    mediaLibrary: 'Media Library',
    uploadMedia: 'Upload Media',
    selectMedia: 'Select Media',
    dragDropHint: 'Drag and drop files here or click to upload',
    uploadProgress: 'Upload Progress',
    uploadSuccess: 'Upload Successful',
    uploadFailed: 'Upload Failed',
    fileSize: 'File Size',
    fileType: 'File Type',
    fileDimensions: 'Dimensions',
    
    // Version Control
    versionHistory: 'Version History',
    versionRestore: 'Restore Version',
    versionCompare: 'Compare Versions',
    currentVersion: 'Current Version',
    previousVersion: 'Previous Version',
    versionBy: 'Modified By',
    versionAt: 'Modified At',
    
    // Review
    review: 'Review',
    approve: 'Approve',
    reject: 'Reject',
    reviewComment: 'Review Comment',
    reviewHistory: 'Review History',
    reviewPending: 'Pending',
    reviewApproved: 'Approved',
    reviewRejected: 'Rejected',
    
    // Categories and Tags
    categories: 'Categories',
    tags: 'Tags',
    addCategory: 'Add Category',
    addTag: 'Add Tag',
    manageCategories: 'Manage Categories',
    manageTags: 'Manage Tags',
    
    // SEO
    seoTitle: 'SEO Title',
    seoDescription: 'SEO Description',
    seoKeywords: 'SEO Keywords',
    seoSlug: 'URL Slug',
    
    // Permissions
    visibility: 'Visibility',
    public: 'Public',
    private: 'Private',
    membersOnly: 'Members Only',
    password: 'Password Protected',
    
    // Scheduled Publishing
    schedulePublish: 'Schedule Publish',
    publishNow: 'Publish Now',
    scheduledFor: 'Scheduled For',
    
    // Error Messages
    errorTitleRequired: 'Title is required',
    errorContentRequired: 'Content is required',
    errorSaveFailed: 'Save failed. Please try again.',
    errorLoadFailed: 'Load failed. Please try again.',
    errorDeleteFailed: 'Delete failed. Please try again.',
    errorUploadFailed: 'Upload failed. Please try again.',
    errorFileTooLarge: 'File is too large',
    errorFileTypeNotSupported: 'File type not supported',
    
    // Confirmation Dialogs
    confirmDelete: 'Are you sure you want to delete this content? This action cannot be undone.',
    confirmPublish: 'Are you sure you want to publish this content?',
    confirmUnpublish: 'Are you sure you want to unpublish this content?',
    confirmRestore: 'Are you sure you want to restore this version?',
    
    // Empty States
    noContent: 'No content yet',
    noResults: 'No results found',
    noVersions: 'No version history',
    noMedia: 'No media files',
  },
};

// 当前语言
let currentLanguage = 'zh';

/**
 * 设置语言
 * @param {string} lang - 语言代码
 */
export function setLanguage(lang) {
  if (SUPPORTED_LANGUAGES.includes(lang)) {
    currentLanguage = lang;
    if (typeof window !== 'undefined') {
      localStorage.setItem('qbit_did_cms_language', lang);
    }
  }
}

/**
 * 获取当前语言
 * @returns {string}
 */
export function getLanguage() {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('qbit_did_cms_language');
    if (saved && SUPPORTED_LANGUAGES.includes(saved)) {
      currentLanguage = saved;
    }
  }
  return currentLanguage;
}

/**
 * 翻译函数
 * @param {string} key - 翻译键
 * @param {Object} params - 替换参数
 * @returns {string}
 */
export function t(key, params) {
  const msgs = messages[getLanguage()] || messages.zh;
  let text = msgs[key] || key;
  
  if (params) {
    Object.keys(params).forEach(k => {
      text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), params[k]);
    });
  }
  
  return text;
}

export default {
  messages,
  SUPPORTED_LANGUAGES,
  setLanguage,
  getLanguage,
  t,
};
